import MyAxios from '../utils/instance.js'
const getname = {
	// 获取模型数据，颜色
	Getnames(modelid) {
		
	    return MyAxios({
	      url: `/toModel//getModelList/${modelid}`,
	    })
	  },
}
export default getname;